import { EnumFields } from './enumerationData';
import { AdditionalPracticeFormFieldEnum } from 'types/circleFixType';
import { TSubscriptionItemFromServer } from './subscription';
import { TCPTCode } from './insuranceBilling';
import { TBackendEligibilityCheckVo } from './insuranceEligibility';

export enum EIntakeFormStatus {
    NONE = 'NONE',
    REQUIRED = 'REQUIRED',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
}

export const WEIGHT_LOSS_15_MINS_TEMPLATE = 'partner-weight-loss-2025';

export enum CouponType {
    HEADWAY = 'HEADWAY',
}

export interface ISales {
    accessToken?: string;
    bookingLinkUrl?: string;
    firstName: string;
    gmail?: string;
    id?: number;
    lastName: string;
    password?: string;
    tel: string;
    title: string;
}

export interface ISalesLinkCheckout {
    fullName: string;
    inviteEmail: string;
    message?: string;
    onboardingCallBookLink?: string;
    payPlan: TSubscriptionItemFromServer;
    presentationEmbeddedLink?: string;
    promotionCode?: string;
}

export type TInsuranceInput = {
    carrier: string;
    insuranceType?: string;
    plan?: string;
    state: string;
    duration?: number;
    dictKey?: string;
    content?: string;
    commercialPayerId?: string;
    governmentPayerId?: string;
};

export enum ChannelPayPlanTypeEnum {
    FREE = 'free',
    PAID = 'paid',
    PREMIUM = 'premium',
    STARTAR = 'starter',
    PLUS = 'plus',
    PRO = 'pro',
}

export enum EGrowthTierSetting {
    STARTER = 'STARTER',
    GROWTH = 'GROWTH',
    SCALING = 'SCALING',
}

export type TGrowthTierSetting = 'STARTER' | 'GROWTH' | 'SCALING';

export type Meta = {
    label: string;
    value?: string | number | number;
};

export type ServerMeta = {
    state: string;
    id: number;
    type: EnumFields | string;
    content: string;
    dictKey: string;
    description?: string | null;
    seq?: number;
    updateAt?: string;
    updateBy?: number;
    createAt?: string;
    createBy?: number;
    insuranceCarrier?: string;
    duration?: number;
    carrier: string;
    plans?: string;
};

//move to common?
export interface PracitceAddressForm {
    [AdditionalPracticeFormFieldEnum.ID]?: number;
    [AdditionalPracticeFormFieldEnum.IS_DEFAULT]: boolean;
    [AdditionalPracticeFormFieldEnum.AS_MAILING]: boolean;
    [AdditionalPracticeFormFieldEnum.NOT_PUBLISH]: boolean;
    [AdditionalPracticeFormFieldEnum.ADDRESS]: string;
    [AdditionalPracticeFormFieldEnum.CITY]: string;
    [AdditionalPracticeFormFieldEnum.STATE]: string;
    [AdditionalPracticeFormFieldEnum.ZIP_CODE]: string;
    [AdditionalPracticeFormFieldEnum.ADDRESS_PUBLIC_TYPE]: AddressPublicType;
}

export type License = {
    id?: number;
    providerId?: number;
    type: string;
    secondType?: string;
    state: string;
    licenseNumber: string;
    expireDate?: string;
    schedule?: string;
    url?: string;
    fullUrl?: string;
    certificatedTitle?: string;
    classTitle?: string;
    hourCompleted?: number;
    licenseType?: string;
};

export type Physician = {
    id: number;
    providerId: number;
    name: string;
    email: string;
    tel: string;
    address: string;
    zip: string;
    state: string;
    npi: string;
    yearExp: number;
    physicianState: string;
    licenseState: string;
    specialities: string;
    effectiveDate: string;
    birthdayDate?: string;
    deaNumber?: string;
    expDate: string;
    url: string;
    fullUrl?: string;
    choice: number;
};

export enum ELicenseType {
    DEA = 'DEA',
    PA = 'PA',
    MIC = 'MIC',
    NURSE = 'NURSE',
    CONTROLLED_SUBSTAN_CECERTIFICATION = 'CSC', //due to db limit
    CONTINUING_MEDICAL_EDUCATION_CERTIFICATES = 'CMEC',
    PRACTICE = 'PRACTICE', //all others set to PRACTICE license
    AUTONOMY = 'AUTONOMY',
    OTHER = 'OTHER',
    BOARD = 'BOARD',
}

export enum ERedirect {
    VERIFY_EMAIL = '1',
    RESUME_FROM_EMAIL = '2',
    RESET_PASSWORD = '3',
}

export type GoogleToken = {
    access_token: string;
    expires_in: number;
    scope: string;
    token_type: 'Bearer';
};

export type BaseUserInfo = {
    firstName?: string;
    gmail: string;
    id?: number;
    lastName?: string;
    tel?: string;
};

export type Service = {
    id: number;
    colorId?: string;
    description?: string;
    duration?: number;
    name: string;
    personAddress?: string;
    personCity?: string;
    personState?: string;
    personType?: string;
    personZip?: string;
    providerId?: number;
    sendForm?: string;
    telehealthType?: string;
    type?: string;
    price?: number;
    intakeForm?: string;
    addressId: number | null;
    enableSlidingScale?: boolean;
    lowestPrice?: number;
    highestPrice?: number;
};

export enum EListStatus {
    UNDER_REVIEW = 'under-review',
    REJECTED = 'rejected',
    LISTED = 'listed',
    NOT_LISTED = 'not-listed',
}

export type Channel = {
    id: number;
    name: string;
    logo: string;
    website: string;
    intro: string;
    ppaChannel?: boolean;
    listStatus: EListStatus;
    currentStep: string;
    channelDesc: string;
    applicationDesc: string;
    avgMonthGainPatient: number;
    estimatedApplicationTime: number;
    channeStepList: string[];
    channelServiceRspList?: Service[];
    //for upcoming using
    initUpvoteCount: number;
    voteCount: number;
    voted: boolean;
    updateTime: string;
    status: string;
    listedCount: number;
    unProcessedCount: number;
    waitingCount: number;
    top: boolean;
    economics?: string;
    news?: string;
    caseStudy?: string;
    type: 'Upcoming' | 'Live';
    tagList: string[];
    tags: string | string[];
    payPlanType: string | null;
    kiwiPrice?: number;
    originalPrice?: number;
    billingCycle?: string;
    subscriptionPriceId?: string;
    freeTrialDays?: number;
    payStatus: string;
    nextPaymentDue: string | null;
    removeStatus: string;
    activeStatus?: EChannelActiveStatus;
    isShow?: boolean;
    klarityPlanLevel: EKlarityPlanLevel;
    isKlarityPlan?: boolean;
    locked?: boolean;
};

//channel/upcoming/list
export type ChannelItemBasic = {
    id: number;
    name: string;
    logo: string;
    rectangleLogo?: string;
    website: string;
    updateTime: string;
    status: string;
    listedCount: number;
    unProcessedCount: number;
    waitingCount: number;
    top: false;
    payPlanType?: ChannelPayPlanTypeEnum;
    activeStatus?: EChannelActiveStatus;
    isShow?: boolean;
};

export enum ChannelType {
    UPCOMING = 'Upcoming',
    ALIVE = 'Alive',
}

export enum ChannelActivationStatus {
    ACTIVE = 'Active',
    INACTIVE = 'Inactive',
}

export enum EChannelServiceConfig {
    NO_LIMIT = 'NO_LIMIT',
    SINGLE_TYPE_MULT_SERVICE = 'SINGLE_TYPE_MULT_SERVICE',
    SINGLE_TYPE_SINGLE_SERVICE = 'SINGLE_TYPE_SINGLE_SERVICE',
}

export enum EChannelActiveStatus {
    ACTIVE = 'A',
    INACTIVE = 'D',
}

export enum EKlarityPlanLevel {
    PREMIUM = 0,
    STARTER = 1,
    PLUS = 2,
    PRO = 3,
}

export type ChannelItem = ChannelItemBasic & {
    intro?: string;
    channelDesc?: string;
    economics?: string;
    news?: string;
    caseStudy?: string;
    type: ChannelType;
    tagList?: string[];
    complete: boolean;
    serviceConfig?: EChannelServiceConfig;
    systemEmail?: string;
    payPlanType?: string;
    kiwiPrice?: number;
    originalPrice?: number;
    billingCycle?: string;
    subscriptionPriceId?: string;
    freeTrialDays?: number;
    reviewAvailable?: boolean;
    reviewRanking?: number | null;
    isShow?: boolean;
    activeStatus: EChannelActiveStatus;
    sameAsKiwi?: boolean;
    klarityPlanLevel: EKlarityPlanLevel;
    klarityChannelDesc?: string;
    klarityEconomics?: string;
    klarityCaseStudy?: string;
    klarityNews: string;
    klarityTagList?: string[];
    klaritySystemEmail?: string;
};

export type IntakeqForm = {
    id: string;
    name: string;
    practitionerId: string;
    archived: boolean;
    anonymous: boolean;
};

export type Review = {
    id: number;
    reviewerName: string;
    reviews: string;
    ratings: number;
    verified: boolean;
    anonymous: boolean;
};

export type ServiceTypeInfo = {
    typeName: string;
    name: string;
    description: string;
};

export enum EProspectType {
    PROSPECT = 'Prospect',
    PATIENT = 'Patient',
}

export type TProspectInsurance = {
    id?: number;
    carrier: string;
    plan: string;
    memberId: string;
    groupId: string;
    front: string | null;
    backend: string | null;
    sort: number;
    firstName?: string;
    lastName?: string;
    insuranceType?: 'PRIMARY' | 'SECONDARY';
    isDefault?: boolean;
    policyHolderType?: 'SELF' | 'SOMEONE_ELSE';
    relationship?: 'CHILD' | 'PARENT' | 'SPOUSE' | 'OTHER';
    holderFirstName?: string;
    holderLastName?: string;
    holderDob?: string;
    holderGender?: string;
    insuranceMd5?: string;
    status?: boolean;
};

export enum EOnBoardingStatus {
    COMPLETE = 'COMPLETE',
    NOT_SENT = 'NOT_SENT',
    SENT = 'SENT',
    IN_PROGRESS = 'IN_PROGRESS',
}

export enum MaritalStatusValue {
    SINGLE = 'SINGLE',
    MARRIED = 'MARRIED',
    DIVORCED = 'DIVORCED',
    WIDOWED = 'WIDOWED',
    DOMESTIC_PARTNER = 'DOMESTIC_PARTNER',
    PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY',
}

export type TPharmacy = {
    address: string;
    city: string;
    name: string;
    ncpDpId: string;
    phone: string;
    state: string;
    zipCode: string;
};

export type TProspectChangeContext = {
    pharmacyUpdated: boolean;
    newPharmacyVersionId: string | null;
    allergyUpdated: boolean;
    newAllergyVersionId: string | null;
    medicationsUpdated: boolean;
    newMedicationsVersionId: string | null;
    medicalHistoryUpdated: boolean;
    newMedicalHistoryVersionId: string | null;
    oldMedicalHistory: string[];
    oldMedications: string[];
    oldAllergies: string[];
    oldPharmacy: TPharmacy[];
};

export type TAllergy = {
    descr: string; // "Anticoagulant Citrate Dextrose (ACD) Solution A";
    routedMedId: number; //164723;
    allergyId: string; // "62433,79367";
    allergyType: string; // "1";
};

export type Prospect = {
    address?: string;
    billing?: string;
    birthday?: string;
    city: string;
    email: string;
    firstName: string;
    gender: string;
    lastName: string;
    notes: string;
    state: string;
    tel: string;
    zip: string;
    idFront: string | null;
    preferMethod?: string;
    type: EProspectType;
    idBack: string | null;
    cardNum?: string; // "123658745",
    cardExpirationDate?: string; // "12/31",
    cardCvc?: string; // "123",

    patientCardNum?: string; // "123658745",
    patientCardExpirationDate?: string; // "12/31",
    patientCardCvc?: string; // "123",

    insurances?: TProspectInsurance[];
    sendInvitationEmail?: boolean;

    channel?: string;
    channelId?: number | string | null;
    preferredName?: string;
    createTime?: string;
    lastReplyBy?: 'PROVIDER' | 'AI';
    lastReplyAt?: string;
    //patientPortal?: string;
    id?: number;
    providerId?: number;
    status?: EStatus;
    ehr?: 'Yes' | 'No';
    lastSurveySendStatus?: string;
    lastSurveySendDate?: string;
    lastSendAnswered?: boolean;
    sendCount?: number;
    isRead?: number;
    onBoardingStatus?: EOnBoardingStatus; //"" take as not sent
    // Insurance eligibility：最新一次 check 摘要（列表/详情接口下发；列表路径只填 status + latestCheckedAt，
    // 详情路径含 detail）。展示转换见 utils/clientEligibility.ts
    latestEligibilityCheck?: TBackendEligibilityCheckVo;
    // 每张保险卡的最后一次 check（元素带 insuranceId，按卡对回 insurances[].id；没查过的卡不在里面，
    // 顺序不固定）。仅详情接口下发；GP identity 的顶层 = boundProviders[0] 那组
    eligibilityCheckCards?: TBackendEligibilityCheckVo[];
    isSample?: boolean;
    creditCardOnFile?: boolean;
    pharmacy?: TPharmacy[];
    medicalHistory?: string[];
    medications?: string[];
    allergies?: string[];
    lastAppointmentType?: string; // "Psychiatric & Mental Health: New patient initial visit",
    lastSpecialty?: string; // "Psychiatric & Mental Health",
    lastSeenDate?: string; // "2025-01-01",
    prescribed?: boolean; // 是否被开过药
    online?: boolean;
    prospectChangeContext: TProspectChangeContext;
    conditionHealth?: {
        featured: string[];
        notSure: boolean;
    };
    medicationHealth?: {
        medications: string[];
        notTaking: boolean;
        others: string[];
    };
    allergyHealth?: {
        hasAllergy: boolean;
        allergies: TAllergy[];
    };
    maritalStatus?: string;
    emergencyContacts?: Array<{
        id: number;
        fullName: string;
        phone: string;
        relationship: string;
        priority: number;
    }>;
    klarityUserId?: number;
    identityId?: number;
    // GP identity 下每位 (provider, sibling prospect) 一条；primary sibling 排第一，其余按 prospect.id ASC。
    // identity 底下是多条 sibling prospect 行，prospect_insurance 挂在 prospect 上——所以每位 provider
    // 名下是各自的一套保险行（id 不同），eligibility 的 insuranceId / clientId 都必须取自选中的这一条
    boundProviders?: {
        avatar?: string;
        credential?: string;
        firstName?: string;
        lastName?: string;
        prospectId?: number;
        providerId?: number;
        // 该 (provider, sibling) 最近一次 check 摘要；仅 GP identity detail（§7）下发，GP 列表恒 null
        latestEligibilityCheck?: TBackendEligibilityCheckVo;
        // 该 sibling 当前 active 保险行；同样仅 §7 下发，无保险时为 []
        insurances?: TProspectInsurance[];
        // 该 sibling 每张保险卡的最后一次 check（元素带 insuranceId；没查过的卡不在里面）；仅 §7 下发
        eligibilityCheckCards?: TBackendEligibilityCheckVo[];
    }[];
    source?: string;
    latestReminderTime?: string;
    /**
     * Client tags for filtering/labeling in Clients pages.
     * Backend already returns/accepts this field; keep optional for compatibility.
     */
    tags?: string[];
    insuranceSwitch?: boolean;
    insuranceSwitchTime?: string;
};

export enum EEmailStatus {
    SENT = 'SENT',
    INBOX = 'INBOX',
}

export type EmailContentItem = {
    id: string;
    subject: string;
    from: string;
    to: string;
    date: string;
    content: string; //has html
    snippet: string;
    body: string; //from ai, without html
    direction: EEmailStatus;
    aiReply?: string;
    isAiReply: 1 | 0;
    isSendByAi: boolean;
    feedback?: 'like' | 'dislike';
};

export type ProspectNotesItem = {
    id: number;
    prospectId: number;
    notes: string;
    createTime: string;
};

export enum EStatus {
    Active = 'Active',
    Archived = 'Archived',
}

export enum EStatusAction {
    Activate = 'Activate', //Active
    Archive = 'Archive', //Archived
}

export type HomeConfig = {
    id?: number;
    title: string;
    headLine: string;
    content: string;
};

export type CityState = {
    city: string;
    state?: string;
};

export type SelectValue = {
    label: string;
    value: string;
    disabled?: boolean;
};

export type UrlString = `http${string}`;

export enum PasswordError {
    LOWERCASE = 'lowercase',
    SPECIAL = 'special',
    UPPERCASE = 'uppercase',
    MINIMUM = 'minimum',
    NUMBER = 'number',
}

export type LocalSEOInfo = {
    state: string;
    landmarks?: string[];
    cities?: string[];
    counties?: string[];
    zip?: string[];
};

export type LocalSEOInfoServer = {
    landmark?: string[];
    city?: string[];
    country?: string[];
    zip?: string[];
};

export type EditLocalSEOInfoServer = {
    landmark?: string;
    city?: string;
    country?: string;
    zip?: string;
};

export enum EServiceType {
    INIT = 'New patient initial visit',
    CONSULTATION = 'Consultation',
    ESTABLISHED_PATIENT_VISIT = 'Established patient visit',
    OTHER_PATIENT_SUPPORT = 'Other patient support',
    CONSULTATION_OVERCHARGE = 'Consultation overcharge',
    MEDICATIONS = 'Medications',
    PRESCRIPTION_SERVICE = 'Prescription service', //old Medication refill
}

export enum EScroeType {
    TERRIBLE = 1,
    BAD = 2,
    OKAY = 3,
    GOOD = 4,
    AMAZING = 5,
}

export type PatientsFeedback = {
    id?: number;
    firstName?: string;
    lastName?: string;
    answerAt: number;
    overallScore: EScroeType;
    email?: string;
    feedbackContent: string;
    isReplied?: boolean;
    patientId: number;
    source?: string;
    phoneNumber?: string;
    isPublic?: boolean;
    isNeedReply?: boolean;
};

export type KlarityServiceTypeInfo = {
    rowId?: number;
    state: ServerMeta;
    serviceId: number;
    serviceType: string;
    customizedServiceName: string;
    earning: number;
    patientCost: number;
    contactType: EContactType[];
    groupAndLimitationId: number;
    qtyPatientGroup: number;
    qtyLimitation: number;
    accpet?: string[];
    limitations?: string[];
    allPatientGroup?: boolean;
    avaPriceInsight?: number;
    insurances?: TInsuranceInput[];
    priorAuthorizationSupport?: boolean;
    superBillSupport?: boolean;
    klarityTemplate?: string;
    intakeFormFlag?: boolean;
    allowControlledMedRefill?: boolean | null;
};

export type KlarityServiceTypeTemplate = {
    id: number;
    iconUri: string;
    serviceType: EServiceType;
    displayName: string;
    description: string;
    mandatory: boolean;
    newPatient: boolean;
    teleHealth: boolean;
    inPerson: boolean;
    defaultDuration: number;
    minDuration: number;
    maxDuration: number;
    switchPatientGroup: boolean;
    qtyPatientGroup: number;
    switchLimitation: boolean;
    qtyLimitation: number;
    createAt: string; //'2024-04-30T08:53:19.000+00:00',
    createBy: number;
    updateAt: string; //'2024-05-01T13:27:08.000+00:00',
    updateBy: number;
    klarityServiceTypePatientGroupList?: IKlarityServiceTypePatientGroup[];
    klarityServiceTypeLimitationList?: IKlarityServiceTypeLimitation[];
    switchPatientGroupLimitation: boolean;
    switchTeleHealthInPerson: boolean;
    patientDirectBookable: boolean;
    klarityTemplate?: string;
};

export type KlarityServiceTypeValue = {
    patientGroupIds: string; //"1, 2"
    limitationIds: string; //"1, 2"
    serviceTypeId: number;
    duration: number;
    id: number;
    mandatory: boolean;
    specId: number;
    teleHealth: boolean;
    inPerson: boolean;
    createAt: string; //'2024-05-07T09:17:17.000+00:00',
    createBy: number;
    updateAt: string; //'2024-05-07T09:17:17.000+00:00',
    updateBy: number;
    switchType: boolean;
    switchPatientGroupLimitation: boolean;
    switchTeleHealthInPerson: boolean;
    klarityTemplate?: string;
};

export type KlarityService = {
    id: number;
    iconUrl: string;
    iconUri: string;
    specialtyName: string;
    description: string;
    commonCondition: string;
    createAt: string;
    createBy: number;
    updateAt: string; //'2024-04-30T12:36:13.000+00:00',
    updateBy: number;
    recommended: boolean;
    have?: boolean;
    serversTypes?: KlarityServiceTypeValue[]; //value from set by ops
    serversTypeNames?: KlarityServiceTypeTemplate[];
    savedValue?: ServerKlarityService[]; //only use for FE
    programId?: number;
    program?: boolean;
    superBillSupport?: boolean;
    priorAuthorizationSupport?: boolean;
    state?: string;
    providerConditions?: string;
};

export type KlarityServicePrice = {
    id: number;
    state: string; //'California',
    specialty: string; //'Psychiatric & Mental Health',
    licensureLevel: 'A' | 'B';
    configType: EServiceConfigPriceType;
    newPatientInitialVisit: number;
    establishedPatientFollowUpVisit: number;
    prescriptionService: number;
    medications: number;
    documentationSupport: number;
    consultation: number;
    createAt: string; //'2024-04-28T16:19:55',
    updateAt: string; //'2024-04-28T16:19:55'
};

export type TKlarityPrice = {
    krc?: number;
    recommendPriceArea?: [number, number, number, number];
    mmu?: number;
    pf?: number;
};

export type TServiceStateItem = {
    itemId?: number;
    state: string; //'CA',
    duration: number;
    earning: number;
    marketingMarkup: number;
    platformFee: number;
    patientCost: number;
    practiceAddressIds: string[]; //['1','2','3',],
    teleHealth: boolean;
    inPerson: boolean;
    shipmentFee: number;
    superBillSupport?: boolean;
    priorAuthorizationSupport?: boolean;
    cashPay?: boolean;
    insurancePay?: boolean;
    allowControlledMedRefill?: boolean;
    maxControlledMedAsyncRefills?: number;
    placeOfServiceCode?: string;
    modifier?: string;
    telehealthPosCode?: string;
    inPersonPosCode?: string;
    telehealthModifierCode?: string;
    inPersonModifierCode?: string;
};

export type TPatientGroupLimitation = {
    id?: number;
    stateGroup: string[]; // ['NY','CA',],
    patientGroup: string[]; // [ '123','456','789',],
    limitation: string[]; //['123123','456456',],
    appliedTeleHealth: boolean;
    appliedInPerson: boolean;
};

export type TConfigMedication = {
    medicationId: number;
    quantity: number;
};

export type ServerKlarityService = {
    serviceId: number | null;
    serviceSpecialtyName: string;
    serviceSpecialtyId: string;
    serviceTypeId: number;
    serviceType: string;
    providerId: number;
    customizedServiceName?: string;
    description: string;
    priceUpdateAt: string; //"2024-05-10T14:59:00"
    disableFlag: boolean;
    serviceStateItems: TServiceStateItem[];
    patientGroupLimitations: TPatientGroupLimitation[];
    medications?: TConfigMedication[];
    displayName?: string;
    cashPay?: boolean;
    insurancePay?: boolean;
    insurances: TInsuranceInput[];
    conditions?: string[];
    klarityTemplate?: string;
    intakeFormFlag?: boolean;
    allowControlledMedRefill?: boolean;
    maxControlledMedAsyncRefills?: number;
    cpts?: TCPTCode[];
};

export type TKlarityStateTPrice = {
    [EServiceType.INIT]: TKlarityPrice;
    [EServiceType.CONSULTATION]: TKlarityPrice;
    [EServiceType.ESTABLISHED_PATIENT_VISIT]: TKlarityPrice;
    [EServiceType.PRESCRIPTION_SERVICE]: TKlarityPrice;
    [EServiceType.OTHER_PATIENT_SUPPORT]: TKlarityPrice;
    [EServiceType.CONSULTATION_OVERCHARGE]: TKlarityPrice;
    [EServiceType.PRESCRIPTION_SERVICE]: TKlarityPrice;
    [EServiceType.MEDICATIONS]: TKlarityPrice;
    [WEIGHT_LOSS_15_MINS_TEMPLATE]: TKlarityPrice;
};

export type TUniprofileFlag = {
    kiwiServiceFlag: boolean;
    klarityServiceFlag: boolean;
};

export enum AddressPublicType {
    WALK_IN = 'Walk-in',
    INVITATION = 'Invitation',
    PRIVATE = 'Private',
}

export enum EContactType {
    TELE_HEALTH = 'Tele-health',
    IN_PERSON = 'In person',
    VIDEO = 'Video',
}

export enum EServiceConfigPriceType {
    KRC = 'KRC',
    PLATFORM_FEE = 'PF',
    MARKETING_MARKUP = 'MMU',
}

export type TConfigTypePrice = {
    [EServiceConfigPriceType.KRC]?: KlarityServicePrice[];
    [EServiceConfigPriceType.MARKETING_MARKUP]?: KlarityServicePrice[];
    [EServiceConfigPriceType.PLATFORM_FEE]?: KlarityServicePrice[];
};

export type TKlarityServiceServerTableItem = {
    itemId: number;
    serviceId: number;
    serviceSpecialtyName: string;
    serviceSpecialtyId: number;
    serviceTypeId: number;
    serviceType: EServiceType;
    displayName: string;
    providerId: number;
    customizedServiceName?: string;
    state: string; //'NY',
    duration: number;
    earning: number;
    patientCost: number;
    teleHealth: boolean;
    inPerson: boolean;
    appliedTeleHealth: boolean;
    appliedInPerson: boolean;
    groupAndLimitationId: number;
    qtyPatientGroup: number;
    qtyLimitation: number;
    allPatientGroup: boolean;
    avaPriceInsight?: number;
    insurances?: TInsuranceInput[];
    priorAuthorizationSupport?: boolean;
    superBillSupport?: boolean;
    klarityTemplate?: string;
    logo?: string;
    cashPay?: boolean;
    insurancePay?: boolean;
    intakeFormFlag?: boolean;
    allowControlledMedRefill?: boolean;
};

export type TKlarityServiceUiTableItem = {
    serviceSpecialtyName: string;
    serviceSpecialtyId: number;
    serviceTypeInfo?: KlarityServiceTypeInfo[];
};

export type TKlarityProgramPackageExternalInfo = {
    id: number;
    programId: number;
    packageId: number;
    patientFacingDesc: string; // "This package is designed for your well-being.",
    whatIncludeInfo: string; //"Includes consultations and tests.",
    disclaimerPolicy: string; //"Read terms and conditions carefully.",
    faq: string; //"[{\"a\":\"Consultations and tests as mentioned.\",\"q\":\"What is included in this package?\"},{\"a\":\"Refunds are subject to specific conditions.\",\"q\":\"Is there a refund policy?\"}]",
    qtyPatientGroup: number;
    patientGroup: string; //"[Adults, Children]",
    isAllPatientGroup: boolean;
    isDeleted: boolean;
    deletedAt: string;
    createAt: string; //"2024-10-29T14:49:29",
    createBy: number;
    updateAt: string; //"2024-10-29T14:49:29",
    updateBy: number;
};

//https://www.figma.com/design/zDzpAC3l8pBTYHpZAH4IRq/Onboarding?node-id=12356-34848&node-type=frame&m=dev
export type TKlarityProgramPackageItem = {
    id: number;
    programId: number;
    packageTitle: string; // "Sample Package-update-test",
    description: string; //"This is a sample health package description.",
    introductionVideoLink: string; // "https://example.com/video.mp4",
    billingFrequencyType: 'One-Time' | 'Monthly'; //"Monthly",
    billingPeriod: number;
    price: number;
    differentFirstPrice: boolean;
    firstPaymentPrice: number;
    providerEarning: number;
    totalPrice: number;
    packageStatus: 'A';
    isKlarityDisplay: boolean;
    patientFacingTitle: string; //"Sample Package for You",
    firstPaymentDuration: number;
    priority: number;
    isDeleted: boolean;
    deletedAt?: string;
    createAt: string; //"2024-10-29T15:01:56",
    createBy: number;
    updateAt: string; // "2024-10-29T15:02:03",
    updateBy: number;
    klarityProgramPackageExternalInfo?: TKlarityProgramPackageExternalInfo;
    klarityProgramPackageSessionItemList?: null;
    klarityProgramMedicationItemList?: null;
    klarityProgramPackageTagItemList?: null;
    recentBooked?: number;
};

export type TKlarityProgramItem = {
    id: number;
    programName: string; // "Compounded Semaglutide Kickstart Plan",
    specialtyName: string; // "Cardiology",
    specialtyId: number;
    description: string; // "An advanced program focusing on heart and circulatory system health.",
    excludeState: string; //"Archived",
    detailInfo: string; //"This program offers an in-depth approach to cardiology with hands-on experience and expert guidance.",
    highlightInfo: string; // "Hands-on labs, expert speakers, and the latest research insights.",
    programStatus: 'A';
    isDeleted: boolean;
    deletedAt?: string;
    createAt?: string;
    createBy: number;
    updateAt: string; //"2024-10-30T10:13:06",
    updateBy: number;
    packages?: TKlarityProgramPackageItem[];
    klarityProgramPackageList: null;
    klarityProgramKeyAdvantageList: null;
    states?: string;
    enrolled: false;
    displayStatus?: 'A' | 'D';
};

export type TKlarityProgramKeyAdvantage = {
    id: number;
    programId: number;
    title: string;
    content: string;
    priority: number;
    isDeleted: false;
    deletedAt: null | string;
    createAt: string; //"2024-10-29T11:26:59",
    createBy: number;
    updateAt: string; //"2024-10-29T11:26:59",
    updateBy: number;
};

export type TKlarityProgramItemDetail = {
    id: number;
    programName: string; // "Compounded Semaglutide Kickstart Plan",
    specialtyName: string; // "Cardiology",
    specialtyId: number;
    description: string; // "An advanced program focusing on heart and circulatory system health.",
    excludeState: string; //"Archived",
    detailInfo: string; //"This program offers an in-depth approach to cardiology with hands-on experience and expert guidance.",
    highlightInfo: string; // "Hands-on labs, expert speakers, and the latest research insights.",
    programStatus: 'A';
    isDeleted: boolean;
    deletedAt?: string;
    createAt?: string;
    createBy: number;
    updateAt: string; //"2024-10-30T10:13:06",
    updateBy: number;
    packages?: TKlarityProgramPackageItem[];
    klarityProgramPackageList: TKlarityProgramPackageItem[];
    klarityProgramKeyAdvantageList?: TKlarityProgramKeyAdvantage[];
    states?: string;
    enrolled: false;
    contractUrl?: string;
    displayStatus?: 'A' | 'D';
};

export interface IKlarityServiceTypePatientGroup {
    id?: number;
    presetId?: number;
    serviceTypeId: number;
    patientGroup: string;
    sequence: number;
    type: string;
    notDelete: boolean;
}

export interface IKlarityServiceTypeLimitation {
    id?: number;
    presetId?: number;
    serviceTypeId: number;
    limitation: string;
    sequence: number;
    type: string;
    notDelete: boolean;
}

export enum EAppointmentContactTypeDictKey {
    VIDEO = 'video',
    IN_PERSON = 'in-person',
}

export type TAppointment = {
    id: string;
    name: string;
    available_contact_types: EAppointmentContactTypeDictKey[];
    length: number;
    required_appointment_type: boolean;
};

export type TPackage = {
    providerId: number;
    ehrProviderId: number;
    intakeqProviderId: string;
    serviceId: string;
    intakeqLocationIdList: null;
    offeringId: string;
    name: string;
    length: number;
    price: number;
    url: string;
    type: EAppointmentContactTypeDictKey[];
    state: string[];
    serviceType: string;
    specialty: string;
    ehrPackageName: string;
    requiredAppointmentType: boolean;
    offeringIncludes: TAppointment[];
    customizedServiceName?: string;
};

export type TProfileLinkInfo = {
    profileLink?: string;
    vfdLink?: string;
};

export type TAirtableProvider = {
    providerId: string; //'652d87df7b4996568e2b5188',
    service?: TPackage[];
    availabilities: unknown;
    appointmentUpdateAt: string; // '2024-05-31T02:06:24.670+00:00',
    id: string; // '652d87df7b4996568e2b5188',
    source: 'A' | 'E';
    firstName: string; // 'Stephanie',
    middleName: string; // '',
    lastName: string; // 'Nazaire',
    headline: string; //'Stephanie Nazaire, FNP-BC',
    years: number;
    state?: string[];
    defaultAddressLat: string;
    defaultAddressLng: string;
    city?: string;
    specialty: string[]; // ['Mental Health'],
    condition: string[]; // ['Anxiety','Depression',],
    credential: string; // 'FNP-BC',
    photos: string[];
    supportPayType: string[]; // ['CASH',],
    insurance?: unknown;
    sortPrice?: unknown;
    signUpDate: string; // '2023-01-06T00:00:00.000+00:00',
    patientRating: string; // '0',
    listingStatus: string; // 'L',
    slug?: string; // 'stephanie-nazaire',
    updateAt: string; // '2024-05-31T02:00:41.758+00:00',
    profileLinks: string[]; // ['https://dev.d2ysjydukc4efk.amplifyapp.com/provider/stephanie-nazaire?state=NY',]
    profileLinkInfo?: TProfileLinkInfo[];
};

export type TSelfEPrescription = {
    id?: number;
    providerId?: number;
    assistantName: string; //'test',
    assistantEmail: string; //'111@qq.com.demo',
    createAt?: string; //'2024-06-13T10:51:30.000+00:00',
    createBy?: number;
    updateAt?: string; // '2024-06-14T01:59:39.000+00:00',
    updateBy?: null | number;
    productAdded?: boolean;
    productPurchased?: boolean;
    productLimitAdded?: boolean;
};

export type TAssistant = {
    id?: number;
    providerId?: number;
    assistantName: string; //'test',
    assistantEmail: string; //'111@qq.com.demo',
    createAt?: string; //'2024-06-13T10:51:30.000+00:00',
    createBy?: number;
    updateAt?: string; // '2024-06-14T01:59:39.000+00:00',
    updateBy?: null | number;
    productAdded?: boolean;
    productPurchased?: boolean;
    productLimitAdded?: boolean;
};

export type TCollaboratingPhysician = {
    id?: number;
    providerId: number;
    choice: number;
    name: string;
    email: string;
    tel: string;
    address: string;
    zip: string;
    state: string; //'AZ',
    physicianState: string; // 'AK',
    npi: string;
    yearExp: number | null;
    licenseState: string;
    specialities: string; //'specialities1',
    effectiveDate: string; // '2023-08-17T00:00:00.000+00:00',
    expDate: string; // '2023-11-23T00:00:00.000+00:00',
    url: string; //  'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/6ced5c1c-9df7-4857-af90-805f3bfffaf8.png'
    deaNumber?: string;
    birthdayDate?: string; // '2023-08-17',
    productAdded?: boolean; //add to cart
    productPurchased?: boolean; //Purchased
    productLimitAdded?: boolean;
};
export interface IStripePaymentInfo {
    card: {
        brand?: string;
        last4?: string;
    };
    id: string;
}

export interface IPaymentInfo {
    type: string;
    expMonth: string;
    expYear: string;
    last4?: string;
    brand: string;
    country: string;
    postalCode?: string;
    bankName?: string;
    accountName?: string;
    paymentMethodId?: string;
    detail?: string; //json string
    id: string;
}

export enum EStepTypes {
    KLARITY_STARTER_SET_UP = 'KLARITY_STARTER_SET_UP',
    EHR_SET_UP = 'EHR_SET_UP',
}

export type TUtmInfo = {
    source?: string;
    medium?: string;
    campaign?: string;
    term?: string;
    content?: string;
};

export enum EDISPUTE_STATUS {
    VALID = 'VALID',
    INVALID = 'INVALID',
    NORMAL = 'NORMAL',
    INVESTIGATION = 'INVESTIGATION',
}

type TProgramPlanRes = {
    label: string;
    content?: string;
    points?: string[];
    points2?: string[];
};

export type TProgramPlan = {
    title: string;
    des: string;
    des2: string;
    earnInit: number;
    earnFollowUp: number;
    earnAll: number;
    res?: TProgramPlanRes[];
};
export interface IProvderProgramSignInput {
    name: string;
    date: string;
    address: string;
}

export type TMedication = {
    id: number;
    medicationName: string;
    fulfillmentPharmacyName: string;
    isBranded: boolean;
    dosage: string; //"0.5ml",
    medicationInfo: string;
    price: number;
    isColdStorage?: boolean;
    shippingRestriction?: string;
    quantity?: number;
    medicationId?: number;
};

export type FormMedications = {
    medications?: Partial<TMedication>[];
};

export enum EDiscoutType {
    PERCENT_OFF = 'PERCENT_OFF',
    AMOUNT_OFF = 'AMOUNT_OFF',
}

export enum ECampaignConfigStatus {
    SCHEDULED = 'Scheduled',
    PAUSED = 'Paused',
    IN_PROGRESS = 'In progress',
    COMPLETE = 'Complete',
}

export type TCampaignConfigData = {
    id: number; //2,
    uid: string; //"909be667bbbf4631864d227b9649d8a3",
    name: string; //"30% off for both referral and referee",
    rules: string; //"Refer a friend and both you and your friend will get 30% off on your next purchase.",
    referralTitle: string; //"Refer a Friend and Get 30% Off",
    referralMarketingContent: string; //"Share the love! Refer a friend and both of you will enjoy 30% off on your next purchase. It's a win-win!",
    refereeDiscountType: EDiscoutType; //"PERCENT_OFF",
    refereeDiscountValue: number; //30.00,
    refereeApplyAllProducts: boolean; //false,
    refereeRewardPrice?: string | null; //"price_1PjKxXLWCWKPYTPjpR1glkou,price_1PjKz9LWCWKPYTPjHF0l6jj3",
    stripeRefereeCouponId: string; //"s3wJcxbN",

    refereeCount: number; //0,
    referrerCount: number; //0,
    landingPageTitle: string; //"Refer a Friend and Save 30%",
    landingPageContent: string; //"Refer a friend and both of you will get 30% off on your next purchase. Start saving today!",
    emailMsgContent: string; //"Hi [Friend's Name],\n\n[Your Name] has referred you to our store. As a special thank you, you'll get 30% off on your next purchase. Enjoy shopping!\n\nBest regards,\nThe [Store Name] Team",
    startDateTime: string | null; //"2023-10-01T00:00:00",
    endDateTime: string | null; //"2024-12-31T23:59:59",
    status: ECampaignConfigStatus; // "Paused",
    createAt: string; //"2024-12-05T07:07:27",
    createBy: number; //43,
    updateAt: string; //"2024-12-05T07:35:35",
    updateBy: number; //43
    referralReward?: {
        //更新带回来
        // "stripeReferrerRewardCouponId": "ref_reward_coupon_123456789",
        // PERCENT_OFF,AMOUNT_OFF
        referrerRewardDiscountType: EDiscoutType; // "PERCENT_OFF",
        referrerRewardDiscountValue: number; // 30,
        referrerRewardApplyAllProducts: boolean; //false,
        referrerRewardPrice?: string; // "price_1PjKxXLWCWKPYTPjpR1glkou,price_1PjKz9LWCWKPYTPjHF0l6jj3, xxx"
    };
};

export type TSFUConfig = {
    specialtyId: number;
    specialtyName: string;
    enable: boolean;
    mappedServiceId: number;
    followUpServiceList?: ServerKlarityService[];
};

export const CALENDLY_TYPE = {
    KIWI_GROUP_PRICE_CONTACT_LINK: 'kiwi_group_price_contact_link',
    KLARITY_GROUP_PRICE_CONTACT_LINK: 'klarity_group_price_contact_link',
    LEARN_ABOUT_UNIPROFILE: 'learn_about_uniprofile',
    ONBOARDING: 'onboarding',
    UNIPROFILE_OPTIMISATION: 'uniprofile_optimisation',
    ACCOUNT_ACTIVATION: 'account_activation',
    INTRODUCTION_TO_KIWI: 'introduction_to_kiwi',
};

export enum EWebinarScheduleType {
    KIWI_GROUP_PRICE_CONTACT_LINK = 'kiwi_group_price_contact_link',
    KLARITY_GROUP_PRICE_CONTACT_LINK = 'klarity_group_price_contact_link',
    LEARN_ABOUT_UNIPROFILE = 'learn_about_uniprofile',
    ONBOARDING = 'onboarding',
    UNIPROFILE_OPTIMISATION = 'uniprofile_optimisation',
    ACCOUNT_ACTIVATION = 'account_activation',
    INTRODUCTION_TO_KIWI = 'introduction_to_kiwi',
    PRO_LISTINGS_SPECIALIST = 'pro_listings_specialist',
    KLARITY_ONBOARDING_HELP = 'klarity_onboarding_help',
    FINANCIALS_SPECIALIST = 'financials_specialist',
    KLARITY_BILLING_WEBINAR = 'klarity_billing_webinar',
}

export type TResource = {
    id?: number;
    title: string;
    description: string;
    category: string;
    resourceUrl: string;
    googleDocId?: string;
    createAt?: string;
    createBy?: string;
    updateAt?: string;
    updateBy?: string;
    privateS3Uri?: string;
    status?: 'Published' | 'Unpublished';
};

export type TResourceHistory = {
    createAt: string; //"2025-02-26T07:59:49.000+00:00"
    createBy: number; // 43
    historyData: string; //"{\"id\":1,\"status\":\"PUBLISHED\"}"
    id: number; //1
    operationBy: number; // 43
    operationEmail: string; //"jianguo.tang@helloklarity.com"
    operationType: string; //"Published"
    sourceId: number;
    sourceType: 'klarity-provider-resources';
};
// {
//     label: 'Video visit',
//     value: 'Video visit',
// },
// {
//     label: 'In-person visit',
//     value: 'In-person visit',
// },
// {
//     label: 'Telephone visit',
//     value: 'Telephone visit',
// }
export enum EAppointmentType {
    VIDEO_VISIT = 'Video visit',
    IN_PERSON_VISIT = 'In-person visit',
    TELEPHONE_VISIT = 'Telephone visit',
}

export enum EServiceTypeLabel {
    INIT = '👋  New patient initial visit',
    CONSULTATION = '💬 Consultation',
    ESTABLISHED_PATIENT_VISIT = '🔄 Established patient visit',
    OTHER_PATIENT_SUPPORT = '📝 Other patient support',
    MEDICATIONS = '💉 Medications',
    PRESCRIPTION_SERVICE = '📃 Prescription service',
}

export type EClient = {
    unitId?: string;
    relationship?:
        'self' | 'child' | 'parent' | 'spouse-or-partner' | 'sibling' | 'friend' | 'my-existing-patient' | 'other';
    firstName?: string;
    lastName?: string;
    preferredName?: string;
    email: string;
    phoneNumber?: string;
    appointmentReason?: string;
    providerId?: number;
    bookingSpecialty?: string;
    bookingCondition?: string;
    bookingAppointmentTime: number;
    clientTimezone: string; //"Asia/Shanghai";
    offerId?: string; //"39913";
    state: string; //"CA";
    appointType: string; //"video";
};

export enum EContactTypeV2 {
    TELEPHONE = 'telephone',
    IN_PERSON = 'in-person',
    VIDEO = 'video',
}

export enum EContactTypeV2Label {
    TELEPHONE = 'Telephone visit',
    IN_PERSON = 'In-person visit',
    VIDEO = 'Video visit',
}

// {
//     "state": "CA",
//         "carrier": "Kaiser",
//             "plans": [
//                 "California - Southern HMO",
//                 "California - Northern HMO"
//             ],
//                 "insuranceType": null
// },
export type TInsuranceServer = {
    state: string;
    carrier: string;
    plans: string[];
    insuranceType: 'common' | 'other';
};

export type TCarrier = {
    name: string;
    plans: string[];
};

export type TInsurance = {
    state: string;
    carriers: TCarrier[];
};

export type CarrierSetting = TCarrier & {
    otherPlans: string;
    commercialPayerId?: string;
    governmentPayerId?: string;
};

export type InsuranceSetting = {
    state: string;
    carriers: CarrierSetting[];
    otherCarriers: string;
};

export type InsuranceSurveyPayload = {
    billingNPI: string;
    insuranceSettings: Record<string, InsuranceSetting>;
};
// {
//     "id": 1204,
//     "prospectId": 108106,
//     "consentType": "HIPAA_PRIVACY",
//     "consentId": 258,
//     "isAccepted": true,
//     "signedAt": "2026-06-23T11:37:21",
//     "signatureName": "prolisting test5",
//     "createdAt": "2026-06-23T11:37:21",
//     "updatedAt": "2026-06-23T11:37:21",
//     "provider": {
//         "providerId": 10006304,
//         "firstName": "0618-owner",
//         "lastName": "chen",
//         "avatar": "https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/test/765d0210-1a97-4dac-a8fe-2762b3b20e03.png"
//     }
// }
export type ProspectForm = {
    id: number; // 44,
    prospectId: number; //106428,
    consentType: string; // "HIPAA_PRIVACY",
    consentId: number; // 81,
    isAccepted: boolean;
    signedAt: string; //"2025-04-27T10:14:43",
    signatureName: string; //"liuxiaocong",
    createdAt: string; //"2025-04-27T10:14:43",
    updatedAt: string; //"2025-04-27T10:14:43"
    provider?: {
        providerId: number;
        firstName: string;
        lastName: string;
        avatar: string;
    };
};

export type TThirdPartyPageData = {
    key: string; // 'db-search',
    title: string; //'Database search',
    url: string; //'https://google.com',
    permissionKey?: string; //'',
    withMenu?: boolean; // false,
};

export type TLeadGenFeeConfig = {
    leadGenFee: number; //120,
    priceStartDate: string; //"2024-11-18T00:00:00"
    specialty: string; //'Psychiatric & Mental Health'
    state: string; // 'CA'
};

export interface TLeadGenFeeInfo {
    leadGenFeeConfigs: TLeadGenFeeConfig[];
    specialty: string; //'Psychiatric & Mental Health'
}

export type TInsuranceForecast = {
    id?: number; //,
    providerId?: number; //null,
    initialVisitReimbursement: number; //120.0,
    followupVisitReimbursement: number; //85.0,
    averageCopay: number; //30.0,
    copayCollectionRatePct: number; //95.5,
    insurancePaymentDelayDays: number; //30,
    followupVisitsPerPatientPerYear: number; //4,
    appointmentAttendanceRatePct: number; //92.0,
    averageCashPayPerVisit: number; //45.0,
    estimatedMonthlyInsuranceIncome: number; //18000.0,
    estimatedMonthlyTotalIncome: number;
    forecastStartMonth?: string; // '2025-01-01',
    assumptionNotes?: string; // 'Sample data for integration testing'
    createdAt?: string; // '2025-11-11 09:38:01',
    updatedAt?: string; // '2025-11-11 09:38:01'
};

export type TInsuranceForecastCalculate = {
    estimatedMonthlyCashPayIncome: number; //0   ,
    estimatedMonthlyInsuranceIncome: number; //0,
    estimatedMonthlyTotalIncome: number; //  0,
    forecastStartMonth: string; // '2025-12-01',
    lastMonthInitialVisitShow: number; // 0,
};

// "kanmonBusinessId": "8e2327e7-e135-4fca-a08f-6d04b780e0e5",
// "kanmonBusinessName": "Xiaocong Liu's Practice",
// "kanmonBusinessStatus": null,
// "kanmonBusinessRequireSubStep": null,
// "kanmonUserId": "4905f704-c814-476c-9a2a-90edd82de16a",
// "kanmonUserState": null,
// "invoicePaybackTerm": 30,
// "paymentActiveStatus": "A",
// "connectToken": "e52ae800-f6b2-489d-aa13-dd649bc90832",
// "joinedProviderCount": 0

// START_FLOW	The business has been created.
// USER_INPUT_REQUIRED	The user has made progress, but some input is required.
// OTHER_USER_INPUT_REQUIRED	An operator is waiting for the primary owner to finish onboarding.
// WAITING_FOR_OFFERS	The business has completed onboarding and is waiting for offers.
// NO_OFFERS_EXTENDED	The business has been evaluated, but there are no loan offers at this time.
// VIEW_OFFERS	Offers have been created for the business. The business can now view them.
// OFFER_ACCEPTED	The business has accepted the offer and are waiting for the loan to close.
// OFFERS_EXPIRED	The business has not accepted the offers, and the offers have expired.
// SERVICING	The loan has closed, and the business can view information about it.
// IN_MANUAL_REVIEW	The business requires manual review, and Kanmon is actively investigating.
// LOAN_APPLICATION_INCOMPLETE	The business did not provide a complete loan application for underwriting.
// LOAN_APPLICATION_WITHDRAWN	The business withdrew the loan application after receiving offers.

export enum EKanmonUserState {
    START_FLOW = 'START_FLOW',
    USER_INPUT_REQUIRED = 'USER_INPUT_REQUIRED',
    OTHER_USER_INPUT_REQUIRED = 'OTHER_USER_INPUT_REQUIRED',
    WAITING_FOR_OFFERS = 'WAITING_FOR_OFFERS',
    NO_OFFERS_EXTENDED = 'NO_OFFERS_EXTENDED',
    VIEW_OFFERS = 'VIEW_OFFERS',
    OFFER_ACCEPTED = 'OFFER_ACCEPTED',
    OFFERS_EXPIRED = 'OFFERS_EXPIRED',
    SERVICING = 'SERVICING',
    IN_MANUAL_REVIEW = 'IN_MANUAL_REVIEW',
    LOAN_APPLICATION_INCOMPLETE = 'LOAN_APPLICATION_INCOMPLETE',
    LOAN_APPLICATION_WITHDRAWN = 'LOAN_APPLICATION_WITHDRAWN',
}

// BUSINESS.NEW_ACCOUNT: A business has been created within Kanmon - {}
// BUSINESS.ONBOARDED: A business has completed all of the onboarding steps within Kanmon and is now awaiting underwriting. - {}
// BUSINESS.OFFERED: A business has been extended 1 or multiple offers. (This event can be triggered multiple times - Refinance / New loan.) - {}
// BUSINESS.ACCEPTED: A business has accepted an offer and is waiting on the closing process. (This event can be triggered multiple times - Refinance / New loan.) - { offerId: "uuid" }
// BUSINESS.OFFERS_EXPIRED: The business has not accepted the offers, and the offers have expired. (This event can be triggered multiple times as businesses can get multiple offers / reoffers.) - {}
// BUSINESS.NOT_OFFERED: The business has been evaluated, but there are no loan offers at this time. - {}
// PRODUCT.ISSUED:A financial product has been issued for a business. (This event can be triggered multiple times - Refinance / New loan.) - { issuedProductId: "uuid" }
// BUSINESS.INPUT_REQUIRED: A business will be asked to provide required data - { subStep: "string" }
// PRODUCT.STATUS_CHANGED: A financing product status changed - { issuedProductId: "uuid", status: "FULLY_PAID" | "CURRENT" | "LATE" | "REFINANCED" | "CLOSED" | "DEFAULTED" }

export enum EKanmonBusinessState {
    NEW_ACCOUNT = 'NEW_ACCOUNT',
    ONBOARDED = 'ONBOARDED',
    OFFERED = 'OFFERED',
    ACCEPTED = 'ACCEPTED',
    OFFERS_EXPIRED = 'OFFERS_EXPIRED',
    NOT_OFFERED = 'NOT_OFFERED',
    INPUT_REQUIRED = 'INPUT_REQUIRED',
    STATUS_CHANGED = 'STATUS_CHANGED',
    ISSUED = 'ISSUED',
}

// {
//     "kanmonBusinessId": "39831981-c697-49d4-bb5d-15b5b60c1d59",
//     "kanmonBusinessName": "Hello Practice22222222",
//     "kanmonBusinessStatus": "INPUT_REQUIRED",
//     "kanmonBusinessRequireSubStep": "RECOLLECT_BANK_DETAILS",
//     "kanmonUserId": "8db7a39c-ba16-4126-b6ad-88aed17614be",
//     "choosedPaybackTermDays": 60,
//     "choosedProductPricePlanId": "302e90bf-e644-47ab-aa65-a221e9639ff1",
//     "paymentActiveStatus": "A",
//     "paymentActiveStatusUpdatedAt": null,
//     "connectToken": "eda0ad7c-0822-41ad-b3fb-c10b9d5a80c5",
//     "joinedProviderCount": 2
// }

export type TKanmonInfo = {
    kanmonBusinessId: string;
    kanmonBusinessName: string;
    kanmonBusinessStatus: EKanmonBusinessState | null;
    kanmonBusinessRequireSubStep: string | null;
    kanmonUserId: string;
    kanmonUserState: EKanmonUserState | null;
    invoicePaybackTerm: number;
    paymentActiveStatus: 'A' | 'D';
    connectToken: string;
    joinedProviderCount: number;
    choosedPaybackTermDays: number;
    choosedProductPricePlanId: string;
    paymentActiveStatusUpdatedAt: string | null;
};

// {
//     "providerId": 1446,
//     "recipients": [
//         {
//             "id": 14,
//             "email": "evankiwi3@gmail.com",
//             "isDefault": true,
//             "associatedNotificationTypes": [
//                 "NEW_VISIT_BOOKED",
//                 "NEW_PATIENT_MESSAGE"
//             ],
//             "createdAt": "2025-11-21T07:24:10"
//         }
//     ],
//     "notificationTypes": [
//         {
//             "id": 16,
//             "notificationType": "NEW_PATIENT_MESSAGE",
//             "enabled": true,
//             "recipientIds": [
//                 14
//             ],
//             "createdAt": "2025-11-21T07:01:26"
//         },
//         {
//             "id": 15,
//             "notificationType": "NEW_VISIT_BOOKED",
//             "enabled": true,
//             "recipientIds": [
//                 14
//             ],
//             "createdAt": "2025-11-21T07:01:26"
//         }
//     ]
// }

export enum ENotificationType {
    NEW_PATIENT_MESSAGE = 'NEW_PATIENT_MESSAGE',
    NEW_VISIT_BOOKED = 'NEW_VISIT_BOOKED',
    NEW_TEXT_VISIT = 'NEW_TEXT_VISIT',
}

export type TNotificationRecipient = {
    id: number;
    email: string;
    isDefault: boolean;
    associatedNotificationTypes: ENotificationType[];
    createdAt: string;
};

export type TNotificationType = {
    id: number;
    notificationType: ENotificationType;
    enabled: boolean;
    recipientIds: number[];
    createdAt: string;
};

export type TNotificationDetail = {
    providerId: number;
    recipients: TNotificationRecipient[];
    notificationTypes: TNotificationType[];
};

// {
//     "contractId": 7,
//     "contractUrl": "https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/fbf5113d-8b87-4dd4-90f3-935f043b777d.html",
//     "contractVersion": "V1.2",
//     "contractPdfUrl": "https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/ee6de9f8-815a-465c-8a10-14694f955db8.pdf",
//     "pdfSignPos": "1,120,418",
//     "pdfDatePos": "1,120,450",
//     "pdfAddressPos": "1,150,120,507",
//     "pdfNamePos": "1,120,529",
//     "bizType": "PAY_PLAN",
//     "createAt": null
// },

export enum EBizType {
    PAY_PLAN = 'PAY_PLAN',
    KLARITY_CODE_OF_CONDUCT = 'KLARITY_CODE_OF_CONDUCT',
    PPA = 'PPA',
    PROGRAM = 'PROGRAM',
}

export type TContractLatestItem = {
    contractId: number;
    contractPdfUrl: string;
    contractUrl: string;
    contractVersion: string;
    bizType: EBizType;
    createAt: string;
    pdfSignPos: string;
    pdfDatePos: string;
    pdfAddressPos: string;
    pdfNamePos: string;
};

// {
//     "prescriptionId": null,
//     "bpProviderId": 1446,
//     "bpClientId": 106665,
//     "ssClientId": null,
//     "clientFirstName": null,
//     "clientLastName": null,
//     "drugId": null,
//     "drugName": "abacavir-lamivudine oral",
//     "drugLine1": "600 mg-300 mg tablet",
//     "drugLine2": null,
//     "drugSigs": null,
//     "drugFormat": null,
//     "refill": null,
//     "duration": null,
//     "quantity": null,
//     "fillDate": null,
//     "approveDate": null,
//     "status": null,
//     "statusTypeId": null,
//     "writtenDate": "2025-10-31T00:59:03",
//     "expires": null,
//     "pharmacyId": null,
//     "pharmacyBusinessName": null,
//     "pharmacyAddressLine1": null,
//     "pharmacyAddressLine2": null,
//     "pharmacyCity": null,
//     "pharmacyState": null,
//     "pharmacyPostalCode": null,
//     "pharmacyPhone": null,
//     "pharmacyFax": null,
//     "practiceName": null,
//     "practiceState": null,
//     "practiceCity": null,
//     "practiceZipcode": null,
//     "practiceAddress1": null,
//     "practiceAddress2": null,
//     "practicePhone": null,
//     "practiceFax": null,
//     "providerFirstName": "Xiaocong",
//     "providerLastName": "Liu",
//     "prescriptionServiceItemId": null,
//     "lastAppointmentAt": "2025-10-09T14:45:32",
//     "maxControlledMedAsyncRefills": null,
//     "allowControlledMedRefill": null,
//     "limited": null
// }

export type TMedicationItem = {
    prescriptionId: number;
    bpProviderId: number;
    bpClientId: number;
    clientFirstName: string | null;
    clientLastName: string | null;
    drugId: number;
    drugName: string;
    drugLine1: string;
    drugLine2: string;
    drugSigs: string[];
    drugFormat: string;
    refill: number;
    duration: number;
    quantity: string;
    fillDate: string;
    approveDate: string | null;
    status: string;
    statusTypeId: number;
    writtenDate: string;
    expires: string;
    pharmacyId: number;
    pharmacyBusinessName: string;
    pharmacyAddressLine1: string;
    pharmacyAddressLine2: string;
    pharmacyCity: string;
    pharmacyState: string;
    pharmacyPostalCode: string;
    pharmacyPhone: string;
    pharmacyFax: string;
    practiceName: string;
    practiceState: string;
    practiceCity: string;
    practiceZipcode: string;
    practiceAddress1: string;
    practiceAddress2: string;
    practicePhone: string;
    practiceFax: string;
    providerFirstName: string;
    providerLastName: string;
    prescriptionServiceItemId: number | null;
    lastAppointmentAt: string;
    maxControlledMedAsyncRefills: number | null;
    allowControlledMedRefill: boolean | null;
    limited: boolean | null;
};

// BASIC_INITIAL_INTAKE_FORM
// BASIC_FOLLOW_UP_INTAKE_FORM
// BASIC_PRESCRIPTION_REFILLS_INTAKE_FORM
// SPECIFIC_INTAKE_FORM

export enum EIntakeFormType {
    BASIC_INITIAL_INTAKE_FORM = 'BASIC_INITIAL_INTAKE_FORM',
    BASIC_FOLLOW_UP_INTAKE_FORM = 'BASIC_FOLLOW_UP_INTAKE_FORM',
    BASIC_PRESCRIPTION_REFILLS_INTAKE_FORM = 'BASIC_PRESCRIPTION_REFILLS_INTAKE_FORM',
    SPECIFIC_INTAKE_FORM = 'SPECIFIC_INTAKE_FORM',
}

export type TIntakeFormConfig = {
    assessmentUuid?: string;
    formType?: EIntakeFormType; // 'BASIC_FOLLOW_UP_INTAKE_FORM';
};

// {
//     "id": 2141,
//     "providerId": 1446,
//     "appointmentName": "patient Evan Liu patient Liu - Psychiatric & Mental Health: New patient initial visit",
//     "clientId": 106711,
//     "startAt": "2026-01-23T23:30:00.000+00:00",
//     "endAt": "2026-01-24T00:00:00.000+00:00",
//     "duration": 30,
//     "actualDuration": 0,
//     "contactType": "video",
//     "appointmentStatus": "scheduled",
//     "appointmentStatusChangedAt": null,
//     "providerConfirm": false,
//     "providerConfirmAt": null,
//     "clientConfirm": false,
//     "clientConfirmAt": null,
//     "externalVideoLink": "https://meeting.klarity-dev.boxpractice.com/dev_mr5mjahm929w",
//     "notes": "",
//     "reason": "",
//     "serviceType": "New patient initial visit",
//     "serviceSpecialty": "Psychiatric & Mental Health",
//     "serviceState": "",
//     "serviceItemId": 0,
//     "location": "",
//     "telephone": "",
//     "createdAt": "2026-01-22T07:30:14Z",
//     "providerTreatmentSubmitted": false,
//     "providerTreatmentSubmittedAt": null,
//     "billingList": null,
//     "intakeFormStatus": "NONE",
//     "intakeFormCompletedAt": null
// }
// {
//     "id": 2382,
//     "providerId": 1761,
//     "appointmentName": "Xiaocong Liu - Psychiatric & Mental Health: Established patient visit",
//     "clientId": 106795,
//     "startAt": "2026-06-18T01:15:00.000+00:00",
//     "endAt": "2026-06-18T01:45:00.000+00:00",
//     "duration": 30,
//     "actualDuration": 0,
//     "contactType": "video",
//     "appointmentStatus": "scheduled",
//     "appointmentStatusChangedAt": null,
//     "providerConfirm": false,
//     "providerConfirmAt": null,
//     "clientConfirm": false,
//     "clientConfirmAt": null,
//     "externalVideoLink": "https://meeting.klarity-dev.boxpractice.com/dev_mrrmfcscmp0s",
//     "notes": "",
//     "reason": "",
//     "serviceType": "Established patient visit",
//     "serviceSpecialty": "Psychiatric & Mental Health",
//     "serviceState": "",
//     "serviceItemId": 1388,
//     "location": "",
//     "telephone": "",
//     "createdAt": "2026-06-17T02:59:49Z",
//     "providerTreatmentSubmitted": false,
//     "providerTreatmentSubmittedAt": null,
//     "billingList": null,
//     "intakeFormStatus": "NONE",
//     "intakeFormCompletedAt": null,
//     "isWithin24hForCancel": true,
//     "provider": {
//         "providerId": 1761,
//         "firstName": "evan provider01",
//         "lastName": "lau",
//         "avatar": "https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/f961b950-1c7b-4d65-8419-083e18e6bac1.png"
//     }
// }
export type TAppointmentItem = {
    id: number;
    providerId: number;
    appointmentName: string;
    clientId: number;
    startAt: string;
    endAt: string;
    duration: number;
    actualDuration: number;
    contactType: string;
    appointmentStatus: string;
    appointmentStatusChangedAt: string | null;
    providerConfirm: boolean;
    providerConfirmAt: string | null;
    clientConfirm: boolean;
    clientConfirmAt: string | null;
    externalVideoLink: string;
    teleHealthLink?: string;
    notes: string;
    reason: string;
    serviceType: string;
    serviceSpecialty: string;
    serviceState: string;
    serviceItemId: number;
    location: string;
    telephone: string;
    createdAt: string;
    providerTreatmentSubmitted: boolean;
    providerTreatmentSubmittedAt: string | null;
    billingList: unknown | null;
    intakeFormStatus: EIntakeFormStatus;
    intakeFormCompletedAt: string | null;
    isWithin24hForCancel: boolean;
    // 该预约是被 EligibilityAutoCancelJob 自动取消的（保险 eligibility 查不过、患者到就诊前 1h
    // 仍未解决）。这类行的 appointmentStatus 同样是 provider-canceled，单靠状态分不出「provider
    // 手动取消」，判定必须走本字段（后端 FRONTEND_INTEGRATION §13 明确要求，不要从状态反推）
    insuranceCheckFailedCanceled?: boolean;
    // 【待后端下发】自动取消是否退了 lead-gen fee。非 lead-gen 来源的预约本就没有这笔费用，
    // 说「已退款」是假话——字段缺省时 tooltip 只说取消原因，不提退款
    leadGenFeeRefunded?: boolean;
    provider: {
        providerId: number;
        firstName: string;
        lastName: string;
        avatar: string;
    };
};

// {
//     "conversationId": "KLARITY_SUPPORT_885ce313fb8944bd9d167d29f3a9e44d",
//     "klarityUserId": 21,
//     "firstName": "Evan Liu",
//     "lastName": "Liu",
//     "lastMessageAt": "2026-02-12T08:54:33"
// }

export type TOpsClient = {
    conversationId: string;
    klarityUserId: number;
    firstName: string;
    lastName: string;
    lastMessageAt: string;
};

// {
//     "providerId": 69,
//     "providerName": "zhengkai zou",
//     "providerCredential": "AACRN,ACCNS-P,ACHPN,ACNP,ACCNS-AG",
//     "providerAvatar": "https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/0deb5a1a-ab37-4689-8bef-dbacadd219ac.png",
//     "yearExp": 11,
//     "uniProFileTags": [],
//     "priorAuthorizationSupport": null,
//     "isDefault": false,
//     "providerEmail": "11@qq.com.demo",
//     "providerSlug": "zhengkai",
//     "providerPracticeEmail": "11@qq.com.demo",
//     "credential": "AACRN,ACCNS-P,ACHPN,ACNP,ACCNS-AG",
//     "lastSpecialty": "Psychiatric & Mental Health",
//     "lastAppointmentType": "Psychiatric & Mental Health: New patient initial visit [FL]",
//     "lastSeenDate": "2026-02-05T16:35:00Z",
//     "hasTextVisit": false,
//     "lastTextVisitId": null,
//     "tel": "191919",
//     "online": false
// },
export type TOpsProvider = {
    providerId: number;
    providerName: string;
    providerCredential: string;
    providerAvatar: string;
    yearExp: number;
    uniProFileTags: string[];
    priorAuthorizationSupport: boolean | null;
    isDefault: boolean;
    providerEmail: string;
    providerSlug: string;
    providerPracticeEmail: string;
    credential: string;
    lastSpecialty: string;
    lastAppointmentType: string;
    lastSeenDate: string;
    hasTextVisit: boolean;
    lastTextVisitId: number | null;
    tel: string;
    online: boolean;
};

export type TCurrentUserInfo = {
    id: number;
    firstName: string;
    lastName: string;
    email: string | null;
};

export type TCurrentProviderInfo = {
    id: number;
    name: string;
    specialties: string | null;
    states: string | null;
};

export type TPracticeInfo = {
    id: number;
    name: string;
};

// {
//     "user": {
//         "id": 4930,
//         "firstName": "Xiaocong",
//         "lastName": "Liu",
//         "email": "evankiwi3@gmail.com"
//     },
//     "actingUser": {
//         "id": 4930,
//         "firstName": "Xiaocong",
//         "lastName": "Liu",
//         "email": "evankiwi3@gmail.com"
//     },
//     "provider": {
//         "id": 1446,
//         "name": "Xiaocong Liu",
//         "specialties": "Psychiatric & Mental Health,Dermatology,Infections",
//         "credential": "AACRN,ACCNS-N",
//         "gender": "Female"
//     },
//     "roleCode": "GROUP_OWNER",
//     "isAdmin": false,
//     "teamMemberId": 303,
//     "organizationId": 303,
//     "portalStatus": "SIGNED_UP",
//     "redirectTo": "PORTAL_HOME",
//     "actingMode": "SELF",
//     "groupPractice": true,
//     "impersonated": false
// }
